import React, { useState } from 'react';
import { useSelector, useDispatch } from "react-redux";
import {
    Box,
    Card,
    CardContent,
    Checkbox,
    Fab,
    FormControl,
    FormControlLabel,
    FormGroup,
    Popover,
    TextField,
    Typography
  } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import moment from "moment";
import "moment/locale/es";
import { useForm } from '../../../hooks/useForm';
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import esLocale from "date-fns/locale/es";
import { AssignmentReturn } from "@material-ui/icons";
import DeleteIcon from '@material-ui/icons/Delete';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import { types } from '../../../types/types';
import { deleteSeguimientoSolicitud, ingresarSeguimientoSolicitud } from '../../../actions/autorizaciones/Autorizaciones';
import ValidatedDatePicker from '../../compartidos/ValidatedDatePicker';
import { TextValidator } from 'react-material-ui-form-validator';

const useStyles = makeStyles((theme) => ({
    root: {
      flexGrow: 1,
    },
    NroAfi: {
      fontSize: 15,
    },
    hideButton: {
      display: "none",
    },
    popover: {
        pointerEvents: 'none',
    },
}));

const SeguimientoSolicitud = ({label = "", mouseEvent = false, seguimiento}) => {

    const dispatch = useDispatch();
    const { solicitudSeleccionada = {}, solicitudSeleccionadaSeguimiento } = useSelector(
      (state) => state.autorizaciones
    );
    let solicitudSeleccionadaSeguimientoDefault = {
        idSeguimiento: 0,
        observacion: "",
        fechaAviso: moment()
    };
    const [
        formValuesSeguimiento,
        handleInputChangeSeguimiento,
        , 
        setearValorSeguimiento, 
        , 
        , 
        , 
        , 
        setearVariosValoresSeguimiento, 
    ] = useForm(
        solicitudSeleccionadaSeguimiento !== null ? solicitudSeleccionadaSeguimiento : solicitudSeleccionadaSeguimientoDefault
        );
    const {
        observacion,
        fechaAviso,
        idSeguimiento
    } = formValuesSeguimiento;

    const classes = useStyles();
    const [anchorEl, setAnchorEl] = useState(null);

    const handlePopoverOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handlePopoverClose = () => {
        setAnchorEl(null);
    };
    const open = Boolean(anchorEl);
    const idPopSeguimiento = open ? 'simple-popover' : undefined;

    const handleSeguimientoSave = () => {
        let data = {
            fecha: fechaAviso,
            idSolicitud: solicitudSeleccionada?.idSolicitud,
            observacion: observacion,
            idSeguimiento: solicitudSeleccionadaSeguimiento === null ? idSeguimiento : solicitudSeleccionadaSeguimiento.idSeguimiento
        };
        dispatch(ingresarSeguimientoSolicitud(data, handlePopoverClose));
    };

    const handleSeguimientoDelete = () => {
        dispatch(deleteSeguimientoSolicitud(solicitudSeleccionadaSeguimiento.idSeguimiento, solicitudSeleccionadaSeguimiento.idSolicitud, handlePopoverClose));
        setearVariosValoresSeguimiento(solicitudSeleccionadaSeguimientoDefault);
    };

    const handleSeguimientoNew = () => {
        dispatch({
            type: types.solicitudesSeguimientoDelete
        }); 
        setearVariosValoresSeguimiento(solicitudSeleccionadaSeguimientoDefault);
    }

    return ( 
        <>
            { mouseEvent === false ? (
                <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"     
                >
                    <FormControl component="fieldset">
                        <FormGroup aria-label="position" row>
                            <FormControlLabel
                                value="end"
                                label={label}
                                control={<Checkbox checked={solicitudSeleccionadaSeguimiento === null ? false : true} />}
                                labelPlacement="start"
                                aria-describedby={idPopSeguimiento} 
                                onClick={handlePopoverOpen}
                            />
                        </FormGroup>
                    </FormControl>
                    <Popover
                        id={idPopSeguimiento}
                        open={open}
                        anchorEl={anchorEl}
                        onClose={handlePopoverClose}
                        anchorOrigin={{
                            vertical: "top",
                            horizontal: "right",
                        }}
                        transformOrigin={{
                            vertical: "center",
                            horizontal: "left",
                        }}
                        PaperProps={{
                            style: { width: "200px", height: "250px" },
                        }}
                    >
                        <Card className={classes.root} variant="outlined">
                            <CardContent>
                                <Typography
                                    color="textSecondary"
                                    gutterBottom
                                >
                                    Aviso de Seguimiento
                                </Typography>
                                <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils} >
                                    <ValidatedDatePicker
                                        margin="normal"
                                        name="fechaAviso"
                                        style={{marginTop: 0}}
                                        label="Fecha Aviso"
                                        format="dd/MM/yyyy"
                                        okLabel="Aceptar"
                                        minDate={new Date()}
                                        clearLabel="Limpiar"
                                        cancelLabel="Cancelar"
                                        value={moment(fechaAviso).isValid() ? moment(fechaAviso) : null}
                                        onChange={(date) => {
                                            setearValorSeguimiento("fechaAviso", date);
                                        }}
                                        KeyboardButtonProps={{
                                            "aria-label": "change date",
                                        }}
                                        validators={["required"]}
                                        errorMessages={["La fecha es requerida"]}
                                    />
                                </MuiPickersUtilsProvider>
                                <TextValidator
                                    id="txtmensajeSeguimiento"
                                    name="observacion"
                                    placeholder="Ingrese Mensaje"
                                    multiline
                                    onChange={handleInputChangeSeguimiento}
                                    value={observacion}
                                    inputProps={{ maxLength: 200}}
                                />
                            </CardContent>
                            <Box
                                className="boxFab"
                                display="flex"
                                justifyContent="space-evenly"
                                alignItems="center"
                                sx={{ width: "100%" }}
                            >
                                <Box
                                    textAlign="center"
                                >
                                    <Typography
                                        color="textSecondary"
                                        gutterBottom
                                        style={{ fontSize: ".8rem" }}
                                        >
                                        Nuevo
                                    </Typography>
                                    <Fab
                                        size="small"
                                        onClick={handleSeguimientoNew}
                                        color="primary"
                                        aria-label="save"
                                        >
                                        <AddCircleOutlineIcon style={{ fontSize: "1.8rem" }}/>
                                    </Fab>
                                </Box>
                                <Box
                                    textAlign="center"
                                >
                                    <Typography
                                        color="textSecondary"
                                        gutterBottom
                                        style={{ fontSize: ".8rem" }}
                                        >
                                        Eliminar
                                    </Typography>
                                    <Fab
                                        size="small"
                                        onClick={handleSeguimientoDelete}
                                        color="primary"
                                        aria-label="delete"
                                        disabled={solicitudSeleccionadaSeguimiento === null}
                                    >
                                        <DeleteIcon style={{ fontSize: "1.8rem" }}/>
                                    </Fab>
                                </Box>
                                <Box
                                textAlign="center"
                                >
                                <Typography
                                    color="textSecondary"
                                    gutterBottom
                                    style={{ fontSize: ".8rem" }}
                                >
                                    Guardar
                                </Typography>
                                <Fab
                                    size="small"
                                    onClick={handleSeguimientoSave}
                                    color="primary"
                                    aria-label="add"
                                >
                                    <AssignmentReturn 
                                    style={{ fontSize: "1.8rem" }}
                                    />
                                </Fab>
                                </Box>
                            </Box>
                        </Card>
                    </Popover>
                </Box>
            ) : (
                <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"     
                >
                    <FormControl component="fieldset">
                        <FormGroup aria-label="position" row>
                            {
                                seguimiento ? 
                                <FormControlLabel
                                    value="end"
                                    label={label}
                                    control={<Checkbox checked={seguimiento === null ? false : true} />}
                                    labelPlacement="start"
                                    aria-owns={open ? 'mouse-over-popover' : undefined}
                                    aria-haspopup="true"
                                    onMouseEnter={handlePopoverOpen}
                                    onMouseLeave={handlePopoverClose}
                                    disabled
                                />
                                :
                                <FormControlLabel
                                    value="end"
                                    label={label}
                                    control={<Checkbox checked={seguimiento === null ? false : true} />}
                                    labelPlacement="start"
                                    aria-owns={open ? 'mouse-over-popover' : undefined}
                                    aria-haspopup="true"
                                    disabled
                                />
                            }
                        </FormGroup>
                    </FormControl>
                    <Popover
                        id="mouse-over-popover"
                        className={classes.popover}
                        open={open}
                        anchorEl={anchorEl}
                        onClose={handlePopoverClose}
                        disableRestoreFocus
                        anchorOrigin={{
                        vertical: 'center',
                        horizontal: 'center',
                        }}
                        transformOrigin={{
                        vertical: 'center',
                        horizontal: 'center',
                        }}
                        PaperProps={{
                            style: { width: "200px" },
                        }}
                    >
                        <Card className={classes.root} variant="outlined">
                            <CardContent>
                                <Typography
                                    color="textSecondary"
                                    gutterBottom
                                >
                                    Aviso de Seguimiento
                                </Typography>
                                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                    <DatePicker
                                        margin="normal"
                                        name="fechaAviso"
                                        style={{marginTop: 0}}
                                        label="Fecha Aviso"
                                        format="dd/MM/yyyy"
                                        // minDate={new Date()}
                                        value={moment(seguimiento?.fechaAviso)}
                                        KeyboardButtonProps={{
                                            'aria-label': 'change date',
                                        }}
                                    />
                                    <TextField
                                        id="txtmensajeSeguimiento"
                                        name="observacion"
                                        label="Observación"
                                        value={seguimiento?.observacion}
                                    />
                                </MuiPickersUtilsProvider>
                            </CardContent>
                        </Card> 
                    </Popover>
                </Box>
            )}
        </>
    );
}
 
export default SeguimientoSolicitud;